import React, { useState, useEffect } from "react";
import { Redirect, Route, Switch } from "react-router";
import { useSelector } from "react-redux";
import Filelibrary from "../OrganizationPages/FileLibrary/fileLibrary";
import Webinars from "../OrganizationPages/Webinars/webinars";
import Profile from "../Pages/Profile/profile";
import CourseView from "../OrganizationPages/Courses/courseView";
import PassCourseVideoView from "../Pages/PassCourse/passCourseVideoView";
import PassCourseView from "../Pages/PassCourse/passCourseView";
import WebinarCalendar from "../OrganizationPages/Webinars/webinarCalendar";
import Home from "../OrganizationPages/Home/home";
import MyCourses from "../OrganizationPages/Courses/myCourses";
import FooterMenu from "../UserPages/FooterMenu/footerMenu";
import Messages from "../OrganizationPages/Messages/messages";
import QuizAttempt from "../Pages/Quiz/quizAttempt";
import QuizAttemptView from "../Pages/Quiz/quizAttemptView";
import NotFoundPage from "../Pages/404/notFoundPage";
import Notifications from "../Pages/Notifications/notifications";
import {
	DEFAULT_LANGUAGE_KEY,
} from "../Constants/mainKeys";
import CuratorWebinars from "../OrganizationPages/Webinars/curatorWebinars";
import PaymentPackage from "../OrganizationAdminPages/PaymentPackage/paymentPackage";
import Paymentpackagehistory from "../OrganizationAdminPages/PaymentPackage/paymentPackageHistory";
import Finances from "../Pages/Overview/finances";
import CoursesForOrgAdmin from "../OrganizationAdminPages/Courses/CoursesForOrgAdmin";
import RolesService from "../Services/rolesService";
import WebinarCalendarInfo from "../OrganizationPages/Webinars/webinarCalendarInfo";
import _Help from "../Pages/Help/_help";
import ContactUs from "../UserPages/ContactUs/contactUs";
import UnderMaintenancePage from "../Pages/UnderMaintenancePage/underMaintenancePage";
import Document from "../OrganizationPages/Document/document";
import DocumentForm from "../MetDepartmentPages/Documents/DocumentForm";
import DocumentView from "../MetDepartmentPages/Documents/DocumentView";
import PaymentSchedule from "../OrganizationPages/PaymentSchedule/paymentSchedule";
import PaymentSchedules from "../OrganizationPages/PaymentSchedule/paymentSchedules";
import AuthenticationByRefreshToken from "../Pages/AuthenticationByRefreshToken/AuthenticationByRefreshToken";
import MainService from "../Services/mainService";
import GamificationDashboard from "../OrganizationPages/Gamification/Dashboard/GamificationDashboard";
import Badges from "../OrganizationPages/Gamification/Badges/Badges";
import Badge from "../OrganizationPages/Gamification/Badges/Badge";
import ShopItems from "../OrganizationPages/Gamification/ShopItems/ShopItems";
import Favorites from "../OrganizationPages/Gamification/Favorites/Favorites";
import ShoppingCart from "../OrganizationPages/Gamification/ShoppingCart/ShoppingCart";
import Leaderboards from "../OrganizationPages/Gamification/Leaderboards/Leaderboards";
import Leaderboard from "../OrganizationPages/Gamification/Leaderboards/Leaderboard";
import ShopItemsAsStudent from "../OrganizationPages/Gamification/ShopItems/ShopItemsAsStudent";
import ResourcesAsStudent from "../OrganizationPages/Gamification/Resources/ResourcesAsStudent";
import Quest from "../OrganizationPages/Gamification/Quests/Quest";
import OnGoingWebinars from "../OrganizationPages/Webinars/onGoingWebinars";
import Overview from "../OrganizationPages/Overview/overview";
import About from "../UserPages/About/about";
import TermsAndCondition from "../UserPages/TermsAndCondition/termsAndCondition";
import CookiesPocicy from "../UserPages/Policy/cookiesPolicy";
import PrivacyPolicy from "../UserPages/PrivacyPolicy/privacyPolicy";
import LogOut from "../Pages/LogOut/LogOut";

function StudentRoute(props) {
	const { role, user } = useSelector(state => state.user);
	const { language } = useSelector(state => state.language);
	const [roleService, setRoleService] = useState(null);

	useEffect(() => {
		MainService.isJson(role) &&
			setRoleService(new RolesService(JSON.parse(role)));
	}, [role]);

	return (
		roleService && (
			<Switch>
				<Route path="/:language" exact component={Home} />
				<Route path="/:language/contact-us" exact component={ContactUs} />
				<Route path="/:language/about/:pageId" exact component={About} />
				<Route
					path="/:language/notifications"
					exact
					component={Notifications}
				/>
				<Route
					path="/:language/cookies-policy/:pageId"
					exact
					component={CookiesPocicy}
				/>
				<Route
					path="/:language/organization-admin/history"
					exact
					component={Paymentpackagehistory}
				/>
				<Route
					path="/:language/privacy-policy/:pageId"
					exact
					component={PrivacyPolicy}
				/>
				<Route
					path="/:language/organization-admin/finances"
					exact
					component={Finances}
				/>
				<Route
					path="/:language/organization-admin/finances/stripesuccess/returnurl"
					exact
					component={Finances}
				/>
				<Route
					path="/:language/organization-admin/finances/stripecancel/returnurl"
					exact
					component={Finances}
				/>
				<Route
					path="/:language/organization-admin/finances/paypalsuccess/returnurl"
					exact
					component={Finances}
				/>
				<Route
					path="/:language/organization-admin/finances/paypalcancel/returnurl"
					exact
					component={Finances}
				/>
				<Route
					path="/:language/organization-admin/finances/cryllexsuccess/returnurl"
					exact
					component={Finances}
				/>
				<Route
					path="/:language/organization-admin/finances/cryllexcancel/returnurl"
					exact
					component={Finances}
				/>
				<Route path="/:language/message" exact component={Messages} />
				<Route
					path="/:language/organization/edit-profile"
					exact
					component={Profile}
				/>
				<Route
					path="/:language/pure/quiz-attempt/:courseId/:quizId"
					exact
					component={QuizAttempt}
				/>
				<Route
					path="/:language/pure/quiz-attempt/view/:courseId/:quizId"
					exact
					component={QuizAttemptView}
				/>
				<Route
					path="/:language/passcourse/:courseId/:studentCourseId"
					exact
					component={PassCourseView}
				/>
				<Route
					path="/:language/passcourse/video/:courseId/:studentCourseId/:topicId"
					exact
					component={PassCourseVideoView}
				/>

				<Route
					path="/:language/organization-admin/payment-package/paypalsuccess/returnurl"
					exact
					component={PaymentPackage}
				/>
				<Route
					path="/:language/organization-admin/payment-package/paypalcancel/returnurl"
					exact
					component={PaymentPackage}
				/>
				<Route
					path="/:language/terms-and-condition/:pageId"
					exact
					component={TermsAndCondition}
				/>
				<Route path="/:language/tariffs/:pageId" exact component={FooterMenu} />
				<Route
					path="/:language/platform-instructions/:pageId"
					exact
					component={FooterMenu}
				/>
				<Route
					path="/:language/company-policy/:pageId"
					exact
					component={FooterMenu}
				/>
				<Route
					path="/:language/personal-data-processing-policy/:pageId"
					exact
					component={FooterMenu}
				/>
				<Route path="/:language/document" exact component={Document} />
				<Route
					path="/:language/document/document-view/:documentId"
					exact
					component={DocumentView}
				/>
				<Route
					path="/:language/document/document-form"
					exact
					component={DocumentForm}
				/>
				<Route
					path="/:language/document/document-form/:documentId"
					exact
					component={DocumentForm}
				/>
				<Route
					path="/:language/organization-admin/courses"
					exact
					component={CoursesForOrgAdmin}
				/>
				<Route
					path="/:language/organization-admin/courses/program/:_programId"
					exact
					component={CoursesForOrgAdmin}
				/>
				<Route
					path="/:language/organization-admin/courses/program/:_programId/:_subjectId"
					exact
					component={CoursesForOrgAdmin}
				/>

				<Route
					path="/:language/course/:courseId"
					exact
					component={CourseView}
				/>
				<Route
					path="/:language/webinar/webinar-calendar/:webinarId"
					exact
					component={WebinarCalendar}
				/>
				<Route
					path="/:language/webinar/webinar-calendar/:webinarCalendarId/info"
					exact
					component={WebinarCalendarInfo}
				/>
				<Route path="/:language/help" exact component={_Help} />
				<Route path="/:language/help/topic/:topicId" exact component={_Help} />
				<Route
					path="/:language/gamification/favorites"
					exact
					component={Favorites}
				/>
				<Route
					path="/:language/gamification/shopping-cart"
					exact
					component={ShoppingCart}
				/>
				<Route path="/:language/help/faq/:faqId" exact component={_Help} />
				<Route
					path="/:language/course/:courseId"
					exact
					component={CourseView}
				/>
				<Route
					path="/:language/gamification/dashboard"
					exact
					component={GamificationDashboard}
				/>
				{roleService.checkRole("webinar_create") && (
					<Route path="/:language/webinar" exact component={CuratorWebinars} />
				)}
				{!roleService.checkRole("webinar_create") && (
					<Route path="/:language/webinar" exact component={Webinars} />
				)}
				{roleService.checkRole("student_course_view") &&
					!roleService.checkRole("instructor_course_view") ? (
					<Route path="/:language/course" exact component={MyCourses} />
				) : null}
				{roleService.checkRole("file_library_student_view") && (
					<Route path="/:language/filelibrary" exact component={Filelibrary} />
				)}
				<Route
					path="/:language/gamification/resources"
					exact
					component={ResourcesAsStudent}
				/>
				<Route
					path="/:language/gamification/leaderboards/:studentId"
					exact
					component={Leaderboards}
				/>
				<Route
					path="/:language/gamification/leaderboard/:leaderboardId"
					exact
					component={Leaderboard}
				/>
				<Route
					path="/:language/gamification/leaderboards"
					exact
					component={Leaderboards}
				/>
				<Route
					path="/:language/gamification/shop"
					exact
					component={ShopItems}
				/>
				<Route path="/:language/gamification/badges" exact component={Badges} />
				<Route
					path="/:language/gamification/quest/:questId"
					exact
					component={Quest}
				/>
				<Route
					path="/:language/gamification/badge/:badgeId"
					exact
					component={Badge}
				/>
				<Route
					path="/:language/ongoing-webinars"
					exact
					component={OnGoingWebinars}
				/>
				<Route
					path="/:language/gamification/shop-items"
					exact
					component={ShopItemsAsStudent}
				/>
				<Route
					path="/:language/organization/overview"
					exact
					component={Overview}
				/>
				<Route
					path="/:language/organization/payment/schedules"
					exact
					component={PaymentSchedules}
				/>
				<Route
					path="/:language/organization/payment/schedule/:innerPaymentId"
					exact
					component={PaymentSchedule}
				/>
				<Route
					path="/:language/authentication/:refreshToken"
					exact
					component={AuthenticationByRefreshToken}
				/>
				<Route path="/:language/not-found/404" exact component={NotFoundPage} />
				<Route
					path="/:language/under-maintenance"
					exact
					component={UnderMaintenancePage}
				/>
				{/* <Route peth="*" component={RedirectComponent} /> */}
				<Route path="/:language/logout" exact component={LogOut} />
				<Redirect to={`/${language ? language : DEFAULT_LANGUAGE_KEY}`} />
			</Switch>
		)
	);
}

export default StudentRoute;
